import type { TrPageConfigInterface } from '@core/utils/TrPageConfig.interface'
import { useLoadingStore } from '@/stores/loading'
import { useSlugHelper } from '@/router/useSlugHelper'

const Names = {
  fr: 'statistiques',
  en: 'statistics'
}

const Config: TrPageConfigInterface = {
  name: Names.fr,
  path: `/${Names.fr}`,
  alias: `/${Names.en}`,
  meta: {
    title: {
      fr: 'Statistiques',
      en: 'Statistics'
    },
    description: {
      fr: 'Une vision claire de la répartition des rendez-vous sur les sept derniers jours sur Clic Santé.',
      en: 'A clear snapshot of the distribution of appointments over the last seven days on Clic Santé.'
    }
  },
  component: () => import('@page/stats/Stats.vue'),
  beforeEnter: async (to, from, next) => {
    const loadingStore = useLoadingStore()
    loadingStore.toggleLoading({ set: true })
    next(await useSlugHelper().checkPageSlug(to.path, Names))
  }
}

export { Config }
